/**
 * Check if all elements in an array are equal.
 */
const allEqual = (arr) => arr.every((val) => val === arr[0]);

export default allEqual;
